export const tableColumnNamesReferee = {
  Candidate: 'candidate',
  'Sectional Committee': 'sectionalCommittee',
  'Referee Status': 'refereeStatus',
  Actions: 'actions',
  'Created at': 'createdAt',
  'Updated at': 'updatedAt',
  'Published at': 'publishedAt',
};
